export default __webpack_public_path__ + "static/media/clip.b89b1bf2.svg";